import { create } from 'zustand'
import { OrderSummaryModel } from '../types/models/order-summary.model'

const initialState: OrderSummaryModel = {
  isUpdate: false,
  date: null,
  time: null,
  discount: 0,
  fullName: '',
  phoneNumber: '',
  email: '',
  step: 0,
  fromPointName: '',
  toPointName: '',
  fromPointDetails: '',
  toPointDetails: '',
  vehicleSizeName: '',
  handLuggage: 0,
  checkedLuggage: 0,
  passengers: 0,
  childSeats: 0,
  booster: 0,
  carrier: 0,
  providerPrice: 0,
  customerPrice: 0,
  totalPrice: 0,
  price: 0,
  oldTotalPrice: 0,
  currency: null,
  promoCodePrice: 0,
}

type OrderSummaryActions = {
  setField: <K extends keyof OrderSummaryModel>(
    key: K,
    value: OrderSummaryModel[K],
  ) => void
  setMany: (data: Partial<OrderSummaryModel>) => void
  reset: () => void
}

type OrderSummaryStore = OrderSummaryModel & OrderSummaryActions

export const useOrderSummaryStore = create<OrderSummaryStore>(set => ({
  ...initialState,

  setField: (key, value) =>
    set(state => ({
      ...state,
      [key]: value,
    })),

  setMany: data =>
    set(state => ({
      ...state,
      ...data,
    })),

  reset() {
    set(initialState)
  },
}))
